export const isTokenExpired = (token) => {
  if (!token) return true; // Jika tidak ada token, berarti expired

  const payload = JSON.parse(atob(token.split(".")[1])); // Decode payload dari token
  const expirationTime = payload.exp * 1000; // Convert ke milidetik

  return Date.now() >= expirationTime; // Periksa apakah sekarang lebih besar atau sama dengan waktu expired
};
